import { FormGroup, FormBuilder } from '@angular/forms';
import { OnInit } from '@angular/core/';
import { MdDialog, MdDialogConfig, MdDialogRef } from '@angular/material';
import { Component, ViewContainerRef } from '@angular/core';

import { AddMappingComponent } from 'app/admin/importclient/mappingfilters/addmapping/add-mapping.component';
import { MappingFilter } from 'app/admin/importclient/mapping-filter.model';
import { ImportClientService } from 'app/admin/importclient/import-client.service';
import { EditMappingComponent } from 'app/admin/importclient/mappingfilters/editmapping/edit-mapping.component';

@Component({
    selector: 'mapping-filters',
    templateUrl: './mapping-filters.component.html'
})
export class MappingFiltersComponent implements OnInit {
    dialogRef: MdDialogRef<any>;
    mappingFilters: Array<MappingFilter>;
    mappingFilterForm: FormGroup;

    constructor(
        public viewContainerRef: ViewContainerRef,
        public dialog: MdDialog,
        private formBuilder: FormBuilder,
        private importClientService: ImportClientService) { }

    ngOnInit() {
        this.buildForm();
        this.importClientService.getMappingFilters().subscribe(response => {
            this.mappingFilters = response;
            this.mappingFilterForm.patchValue({
                provider: this.getProviders()[0],
                version: this.getVersions()[0],
                condition: this.getConditions()[0],
            });
        });
    }

    getVersions() {
        if (this.mappingFilters) {
            return this.mappingFilters.map(mappingFilter => mappingFilter.newVersion);
        }
        return [];
    }

    getProviders() {
        if (this.mappingFilters) {
            return this.mappingFilters.map(mappingFilter => mappingFilter.newProvider);
        }
        return [];
    }

    getConditions() {
        if (this.mappingFilters) {
            return this.mappingFilters.map(mappingFilter => mappingFilter.newCondition);
        }
        return [];
    }

    openAddNewMapping(action: string) {
        let config = new MdDialogConfig();
        config.viewContainerRef = this.viewContainerRef;
        this.dialogRef = this.dialog.open(AddMappingComponent, config);
        this.dialogRef.afterClosed().subscribe(result => {
            this.dialogRef = null;
        });
    }

    openEditMapping(action: string) {
        let config = new MdDialogConfig();
        config.viewContainerRef = this.viewContainerRef;
        this.dialogRef = this.dialog.open(EditMappingComponent, config);
        this.dialogRef.afterClosed().subscribe(result => {
            this.dialogRef = null;
        });
    }

    buildForm() {
        this.mappingFilterForm = this.formBuilder.group({
            provider: [{ value: '', }],
            version: [{ value: '', }],
            condition: [{ value: '', }],
        });
    }

    onSubmit({ value, valid }) {
        this.importClientService.sendFilter(value);
    }
}



// WEBPACK FOOTER //
// ./src/app/admin/importclient/mappingfilters/mapping-filters.component.ts